<template>
  <div class="flex flex-col items-center justify-between p-8 xl1_flex-row gap-8">
    <button v-if="loading" class="upload-choice"><FontAwesomeIcon icon="circle-notch" spin size="2x" /></button>
    <button v-else class="upload-choice" @click="openDialog">
      <FontAwesomeIcon icon="upload" size="2x" />
      Upload {{ fileType }}
      <input ref="fileField" class="hidden" type="file" :accept="mimeType" data-testid="file-field" @change="handleFiles" />
    </button>
    <div class="uppercase">or</div>
    <button class="upload-choice" :disabled="loading" @click="$emit('goto:shelf')">
      <FontAwesomeIcon icon="swatchbook" size="2x" />
      Choose from a previously uploaded {{ fileType }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { ref, toRefs } from 'vue'

const props = defineProps({
  companyId: {
    type: Number as PropType<number | null>,
    default: null,
  },
  folderId: {
    type: Number as PropType<number | null>,
    default: null,
  },
  fileType: {
    type: String,
    required: true,
  },
  mimeType: {
    type: String,
    required: true,
  },
  maxResolution: {
    type: Array as unknown as PropType<[number, number] | null>,
    default: null,
  },
})

const emit = defineEmits(['choose-file', 'goto:shelf', 'error'])

const fileField = ref<HTMLInputElement | null>(null)
const buttonsRef = ref(false)
const { companyId, folderId, maxResolution } = toRefs(props)
const { loading, handleFiles } = useShelfUpload({
  companyId,
  folderId,
  maxResolution,
  onError(err: string) {
    emit('error', err)
  },
  clearError() {
    emit('error', null)
  },
  onUpload(payload: any) {
    emit('choose-file', payload)
  },
})

function openDialog() {
  fileField.value?.click()
}
</script>

<style lang="stylus" scoped>
button.upload-choice
  @apply flex flex-col items-center justify-center gap-4
  @apply w-58 h-34
  @apply text-black border border-gray-300 rounded-md bg-white shadow-sm transition-colors
  &:hover
    @apply border-gray-500
</style>
